import React, { useEffect, useState } from "react";
import "../Assets/Css/home.css";
import { Card, Container, Row, Col, Collapse } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import img1 from "../Assets/Image/machine1.jpg";
import img2 from "../Assets/Image/machine2.jpg";
import img3 from "../Assets/Image/machine3.jpg";
import img4 from "../Assets/Image/machine4.jpg";
import img5 from "../Assets/Image/machine5.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { FaIndustry } from "react-icons/fa";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { FaAngleRight } from "react-icons/fa";
import { Helmet } from "react-helmet";

function ProductsData() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeIdx, setActiveIdx] = useState(null);
  const handleTitleClick = (idx) =>
    setActiveIdx((prev) => (prev === idx ? null : idx));
  const handleClick = (index) => {
    setOpenStates((prev) => prev.map((val, i) => (i === index ? !val : val)));
  };
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const productDetails = [
    {
      title: "Automated Foil Cutting Machine",
      short: "Precision cutting for copper foils",
      detail: "Ensures clean, consistent cuts for laminated connectors.",
      image: img1,
    },
    {
      title: "Resistance Welding Machine for Flexibles",
      short: "Robust welding for laminated flexibles",
      detail:
        "High-quality resistance welds ensuring uniform electrical conductivity.",
      image: img2,
    },
    {
      title: "Silver Brazing Machines",
      short: "Superior contact area joining",
      detail:
        "Uniform silver brazing with precise control for low contact resistance.",
      image: img3,
    },
    {
      title: "Vertical Milling Machines (VMC)",
      short: "Advanced vertical machining",
      detail: "Enables high-precision shaping of busbars and connectors.",
      image: img4,
    },
    {
      title: "Fabricated Busbar Processing Machine",
      short: "Complete busbar fabrication",
      detail: "Handles cutting, punching, and forming of busbars.",
      image: img5,
    },
  ];
  const [openStates, setOpenStates] = useState(productDetails.map(() => false));

  const resistanceCapacity = {
    title: "Resistance Welded Flexible Capacity",
    range: "Fusion Area/Length: 10 to 200 mm",
    specs: [
      { label: "Foil Thickness", value: "0.035mm – 0.3mm" },
      { label: "Total Thickness", value: "1mm – 50mm" },
      { label: "Width", value: "15mm – 250mm" },
      { label: "Length", value: "50mm – 2000mm" },
      { label: "Ampere Rating", value: "40A – 10000A" },
    ],
  };

  const busbarCapacity = {
    title: "Fabricated Busbar Manufacturing Capacity",
    range: "Bar Thickness: 1mm – 50mm",
    specs: [
      { label: "Bar Width", value: "10mm – 200mm" },
      { label: "Bar Length", value: "30mm – 2000mm" },
    ],
  };

  const manufacturingFeatures = [
    "We use high purity ETP copper foils/bars as per IS and EN Standards.",
    "High Purity Copper foils/bars, hardness from H40 to H90 & special H110 HCP copper.",
    "Various laminated flexible connectors from thickness 2.0 to50mm.",
    "Uniform solidification across the full width ranging 10 to 150mm.",
    "High accuracy and tolerance in contact area thickness and length.",
    "Facility to obtain any shape for the connectors.",
    "Consistent welding and surface finish.",
    "We offer Bare, Tin & Silver plated contact area with uniform finish.",
    "We produce fabricated copper/aluminium busbars as per Customer specifications.",
    "Our tool room facility enables precise tooling for copper links and connectors.",
    "Our machinery produces machined components from copper, aluminium, brass etc.",
  ];

  return (
    <div>
      <Helmet>
        <title>Products & Manufacturing Capabilities | Delta Engineering</title>
        <meta
          name="description"
          content="Explore Delta Engineering's durable copper solutions and advanced manufacturing facilities. Our machinery includes automated foil cutting, resistance welding, silver brazing, VMC milling, and complete busbar fabrication."
        />
        <meta
          name="keywords"
          content="Copper Products, Copper Busbars, Laminated Flexibles, Silver Brazing, Resistance Welding, Automated Foil Cutting, Vertical Milling Machines, Fabricated Busbar Processing, Delta Engineering Manufacturing"
        />

        {/* Open Graph / Facebook */}
        <meta
          property="og:title"
          content="Products & Manufacturing Capabilities | Delta Engineering"
        />
        <meta
          property="og:description"
          content="High-performance copper products and advanced machinery: foil cutting, welding, brazing, VMC machining, and busbar fabrication."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/products-data"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/products-machinery.jpg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Products & Manufacturing Capabilities | Delta Engineering"
        />
        <meta
          name="twitter:description"
          content="Discover Delta Engineering’s advanced copper solutions and machinery for busbar fabrication, laminated flexibles, and precision machining."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/products-machinery.jpg"
        />
      </Helmet>

      <section className="banner5-section text-white d-flex align-items-center justify-content-center text-center position-relative">
        <div className="overlay-layer"></div>

        <div className="banner2-overlay px-3 position-relative">
          <h2 className="banner2-title" data-aos="zoom-in" data-aos-delay="300">
            Products<span> Data</span>
          </h2>
          <p
            className="banner2-subtitle"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            Delivering durable and high-performance copper solutions for every
            industry need.
          </p>
        </div>
      </section>
      <section className="py-3 bg-light pt-2" id="product-showcase">
        <Container>
          <div className="text-center mb-5">
            <h2
              className="fw-bold section-title text-primary position-relative d-inline-block"
              data-aos="fade-up"
            >
              Our Machinery Ranges
              <span className="title-underline"></span>
            </h2>
            <p
              className="machinery-subtitle"
              data-aos="fade-up"
              data-aos-delay="150"
              data-aos-duration="800"
            >
              High-precision equipment for{" "}
              <strong>advanced manufacturing</strong>
            </p>
            <Row className="g-4 my-3 pt-2">
              {[resistanceCapacity, busbarCapacity].map((capacity, i) => (
                <Col
                  md={6}
                  key={i}
                  data-aos="fade-up"
                  data-aos-delay={i * 200}
                  data-aos-duration="800"
                >
                  <Card className="border-0 shadow h-100">
                    <div
                      className="card-header text-white"
                      style={{
                        background: "linear-gradient(90deg, #007BFF, #00BFFF)",
                        fontWeight: "600",
                        fontSize: "1.1rem",
                      }}
                    >
                      <FaIndustry className="me-2" />
                      {capacity.title}
                    </div>
                    <Card.Body>
                      <p className="text-muted fw-semibold">{capacity.range}</p>
                      <ul className="list-group list-group-flush">
                        {capacity.specs.map((spec, j) => (
                          <li
                            key={j}
                            className="list-group-item d-flex justify-content-between"
                          >
                            <span>{spec.label}</span>
                            <span className="fw-semibold text-dark">
                              {spec.value}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>

          <div
            className="mt-5 py-4 bg-white manufacturing-features rounded shadow"
            data-aos="fade-up"
          >
            <div className="text-center">
              <h3 className="fw-bold mb-3 section-title">
                Our Product Manufacturing Range
                <span className="title-underline"></span>
              </h3>
            </div>
            <Row className="justify-content-center">
              <Col lg={10}>
                <Row>
                  <Col md={6}>
                    <ul className="ps-3 list-unstyled">
                      {manufacturingFeatures
                        .slice(0, Math.ceil(manufacturingFeatures.length / 2))
                        .map((feature, idx) => (
                          <li
                            key={idx}
                            className={`mb-2 feature-item rounded px-2 py-1 ${
                              activeIndex === idx ? "active-feature" : ""
                            }`}
                            onClick={() => setActiveIndex(idx)}
                          >
                            <span className="me-2 text-primary">
                              <FaAngleRight />
                            </span>
                            {feature}
                          </li>
                        ))}
                    </ul>
                  </Col>

                  <Col md={6}>
                    <ul className="ps-3 list-unstyled">
                      {manufacturingFeatures
                        .slice(Math.ceil(manufacturingFeatures.length / 2))
                        .map((feature, idx) => {
                          const adjustedIdx =
                            idx + Math.ceil(manufacturingFeatures.length / 2);
                          return (
                            <li
                              key={adjustedIdx}
                              className={`mb-2 feature-item rounded px-2 py-1 ${
                                activeIndex === adjustedIdx
                                  ? "active-feature"
                                  : ""
                              }`}
                              onClick={() => setActiveIndex(adjustedIdx)}
                            >
                              <span className="me-2 text-primary">
                                <FaAngleRight />
                              </span>
                              {feature}
                            </li>
                          );
                        })}
                    </ul>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Container>
        <div className="text-center mb-3 pt-4">
          <h3 className="fw-bold section-title position-relative d-inline-block">
            Our Manufactiring Facilities
            <span className="title-underline"></span>
          </h3>
        </div>
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{
            delay: 4000,
            disableOnInteraction: true,
          }}
          loop
          breakpoints={{
            576: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
          }}
        >
          {productDetails.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="">
                <Card
                  className={`shadow-sm border-0 hover-zoom cursor-pointer machinery-card`}
                  onClick={() => handleClick(index)}
                  data-aos="zoom-in-up"
                  data-aos-delay={index * 100}
                >
                  <Card.Img
                    variant="top"
                    src={item.image}
                    alt={item.title}
                    style={{ height: "180px", objectFit: "fill" }}
                    loading="lazy"
                  />

                  <Card.Body className="text-center">
                    <h5 className="fw-bold text-primary">{item.title}</h5>
                    <p className="text-muted small">{item.short}</p>

                    <div
                      style={{
                        overflow: "hidden",
                        transition: "max-height 0.4s ease",
                      }}
                    >
                      <Collapse in={openStates[index]}>
                        <div className="text-start">
                          <p className="text-secondary small mb-0">
                            {item.detail}
                          </p>
                        </div>
                      </Collapse>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    </div>
  );
}

export default ProductsData;
